import { useEffect, useRef, useState } from 'react'
import Swal from 'sweetalert2'
import { getAllArticulos } from '../../../Services/articuloService'

const usePagination = (history, isActive = true) => {
  let token = JSON.parse(atob(sessionStorage.getItem('token').split('.')[1]))
  let rol = token.authorities[0]

  const [articulos, setArticulos] = useState([])
  const [isLoad, setIsLoad] = useState(true)

  const [page, setPage] = useState(0)
  const [totalRegister, setTotalRegister] = useState(0)
  const [totalPage, setTotalPage] = useState(0)
  const [query, setQuery] = useState('')
  const [searchCriteria, setSearchCriteria] = useState('nombre') // 'nombre', 'codigo', 'codigoBarra'
  const lastSearchRef = useRef('')

  const getSearchParams = (searchTerm) => {
    const trimmed = searchTerm.trim()
    return {
      nombre: searchCriteria === 'nombre' ? trimmed : '',
      codigo: searchCriteria === 'codigo' ? trimmed : '',
      codigoBarra: searchCriteria === 'codigoBarra' ? trimmed : ''
    }
  }

  const fetchArticulos = (pageNum, searchTerm) => {
    const { nombre, codigo, codigoBarra } = getSearchParams(searchTerm)
    return getAllArticulos(isActive, pageNum, nombre, 50, codigo, codigoBarra)
  }

  useEffect(() => {
    if (rol !== 'ROLE_ADMIN') history.goBack()

    if (isLoad) {
      fetchArticulos(0, query)
        .then((res) => {
          setArticulos(res.data.content)
          setTotalRegister(res.data.totalElements)
          setTotalPage(res.data.totalPages)
          setIsLoad(false)
        })
        .catch((error) => console.log(error.response))
    } else {
      setIsLoad(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoad])

  const nextPage = () => {
    if (totalPage === 0 || page === totalPage - 1) {
      Swal.fire({
        toast: true,
        position: 'top',
        title: 'No hay mas páginas',
        type: 'info',
        showConfirmButton: false,
        timer: 1000,
      })
      return
    }

    fetchArticulos(page + 1, query)
      .then((res) => {
        setPage(page + 1)
        setArticulos(res.data.content)
        setTotalRegister(res.data.totalElements)
        setTotalPage(res.data.totalPages)
        setIsLoad(false)
      })
      .catch((err) => console.log('error'))
  }

  const previousPage = () => {
    if (page === 0) {
      Swal.fire({
        toast: true,
        position: 'top',
        title: 'No hay mas páginas',
        type: 'info',
        showConfirmButton: false,
        timer: 1000,
      })
      return
    }

    fetchArticulos(page - 1, query)
      .then((res) => {
        setPage(page - 1)
        setArticulos(res.data.content)
        setTotalRegister(res.data.totalElements)
        setTotalPage(res.data.totalPages)
        setIsLoad(false)
      })
      .catch((err) => console.log('error'))
  }

  const handleBuscador = (e) => {
    setQuery(e.target.value)
    if (e.key === 'Enter') {
      const trimmedValue = e.target.value.trim()

      if (trimmedValue === '' && lastSearchRef.current !== '') {
        fetchArticulos(0, '')
          .then((res) => {
            setPage(0)
            setArticulos(res.data.content)
            setTotalRegister(res.data.totalElements)
            setTotalPage(res.data.totalPages)
            setIsLoad(false)
            lastSearchRef.current = ''
          })
          .catch((err) => console.log('error'))
      } else if (trimmedValue !== '' && trimmedValue !== lastSearchRef.current) {
        fetchArticulos(0, trimmedValue)
          .then((res) => {
            setPage(0)
            setArticulos(res.data.content)
            setTotalRegister(res.data.totalElements)
            setTotalPage(res.data.totalPages)
            setIsLoad(false)
            lastSearchRef.current = trimmedValue
          })
          .catch((err) => console.log('error'))
      }
    }
  }

  const getCriteriaLabel = () => {
    switch (searchCriteria) {
      case 'codigo':
        return 'Código'
      case 'codigoBarra':
        return 'Código de Barra'
      default:
        return 'Nombre'
    }
  }

  const onChangeArticulo = (e) => {
    setQuery(e.target.value)
    if (e.key === 'Enter') {
      fetchArticulos(0, e.target.value)
        .then((res) => {
          setPage(0)
          setArticulos(res.data.content)
          setTotalRegister(res.data.totalElements)
          setTotalPage(res.data.totalPages)
          setIsLoad(false)
        })
        .catch((error) => console.log(error.response))
    }
  }

  return {
    articulos,
    setIsLoad,
    page,
    totalRegister,
    totalPage,
    handleBuscador,
    nextPage,
    previousPage,
    setQuery,
    onChangeArticulo,
    searchCriteria,
    setSearchCriteria,
    getCriteriaLabel
  }
}

export default usePagination
